/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class SmartTilePropProductCategory implements angular.IComponentOptions {
        templateUrl = 'app/components/controls/smartCenterDesigner/propertyViews/smartTilePropProductCategory.component.html';
        bindings: any = {
            prop: '=?',
            selectionChanged: '&?',
        };
        controller = class SmartTilePropProductCategoryController {
            static $inject = [
                'meevo.components.common.DataService',
                '$translate'
            ];

            public prop: Meevo.Model.SmartTileParameter;
            public selectedProductCategory: Model.ProductCategory;
            public allOption: Model.ProductCategory;
            public selectionChanged: Function;

            constructor(
                protected dataService: Components.BaseClasses.IDataService,
                protected $translate: angular.translate.ITranslateService                
            ) {
                this.allOption = {
                    id: null,
                    displayName: this.$translate.instant("LABEL_ALL_PRODUCT_CATEGORIES"),
                };
            }

            $onInit(): void {
                if (this.prop && this.prop.parameterValue) {
                    this.selectedProductCategory = {
                        id: this.prop.parameterValue,
                        displayName: this.prop.parameterDisplayName
                    };
                } else {
                    this.selectedProductCategory = this.allOption;
                }
            }

            onSelectionChanged(): void {
                if (!this.selectedProductCategory) {
                    this.selectedProductCategory = this.allOption;
                }
                this.prop.parameterValue = this.selectedProductCategory.id;
                this.prop.parameterDisplayName = this.selectedProductCategory.displayName;
                this.selectionChanged({ selection: this.selectedProductCategory });
            }

            addProductCategoryAll(response: any, request: any) {
                if (request.pageNumber === 0) {
                    response.splice(0, 0, this.allOption);
                    return response;
                }                
            }            
        }
    }

    angular.module('meevo.components.controls')
        .component('stpProductCategory', new SmartTilePropProductCategory());
}
